import { createGlobalStyle } from 'styled-components';
import { Theme } from '@user-portal/wikr-components';

import resetStyles from './styles/reset';
import { color } from './selectors';

const GlobalStyle = createGlobalStyle<{ rootVariables: string; theme: Theme }>`
    ${resetStyles}

    :root {
        ${({ rootVariables }) => rootVariables}
    }

    body,
    html{
        height: 100%;
        }

        textarea {
        font-family: var(--font-family) !important;
        }

    body {
        background: ${color('secondary-default')};

        &.ReactModal__Body--open {
            overflow: hidden;
        }
    }

`;

export default GlobalStyle;
